import { writable } from 'svelte/store';
export const storePlenaries = writable([]);
export const storePlenariesError = writable("");
export const storeNextPlenaryDate = writable("");
export const storeNextPlenaryDateError = writable("");
